import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { faCircleCheck, faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import Button, { ButtonType } from "../Button";
import "./Modal.scss";
import { getSizeClass } from "./ModalSizeClasses";

/**
 * @readonly
 * @enum {number}
 */
export const MessageModalType = {
	Error: 1,
	Warning: 2,
	Information: 3,
	Question: 4
};

/**
 * Properties Object definition used in the Button component.
 * @typedef {Object} MessageModalProps
 * @property {string} title
 * @property {MessageModalType} type
 * @property {Function} onClick
 * @property {string} children
 * @property {string} [questionYesLabel]        // default "Yes"
 * @property {string} [questionNoLabel]         // default "No"
 * @property {ButtonType} [questionYesType]     // default Primary
 * @property {ButtonType} [questionNoType]      // default Secondary
 * @property {boolean} [questionReverseOrder]   // default false; when true => No left, Yes right
 */

/**
 * @component
 * @param {MessageModalProps} props
 */
const MessageModal = (props) => {
	const [visible, setVisible] = useState(true);

	const {
		questionYesLabel = "Yes",
		questionNoLabel = "No",
		questionYesType = ButtonType.Primary,
		questionNoType = ButtonType.Secondary,
		questionReverseOrder = false
	} = props;

	const header = (
		<div><h1>{props.title}</h1></div>
	);

	const questionButtons = (
		<>
			{questionReverseOrder ? (
				<div>
					<Button type={questionNoType} icon={faXmark} label={questionNoLabel} onClick={() => props.onClick(false)} />
					<Button type={questionYesType} icon={faCheck} label={questionYesLabel} onClick={() => props.onClick(true)} />
				</div>
			) : (
				<div>
					<Button type={questionYesType} icon={faCheck} label={questionYesLabel} onClick={() => props.onClick(true)} />
					<Button type={questionNoType} icon={faXmark} label={questionNoLabel} onClick={() => props.onClick(false)} />
				</div>
			)}
		</>
	);

	const footer = (
		<>
			{props.type && props.type === MessageModalType.Question ?
				questionButtons
				:(
					<div>
						<Button type={ButtonType.Primary} icon={faCircleCheck} label={"Ok"} onClick={props.onClick} />
					</div>
				)
			}
		</>
	);

	const sizeClass = getSizeClass(props.size);

	useEffect(() => {
		if (visible) {
			document.body.classList.add("body-no-scroll");
		} else {
			document.body.classList.remove("body-no-scroll");
		}
		return () => {
			document.body.classList.remove("body-no-scroll");
		};
	}, [visible]);

	return (
		<Dialog id="uc-modal" className={sizeClass} position="center" closable={false} visible={visible} header={header} footer={footer} onHide={() => setVisible(false)}>
			<hr />
			<div className="body font_s">
				{props.children}
			</div>
			<hr />
		</Dialog>
	);
};

export default MessageModal;
